













import { Component, Vue } from 'vue-property-decorator'
import WaveSpinner from '@/components/spinners/WaveSpinner.vue'
import LoginForm from '@/components/LoginForm.vue'

@Component({
  components: { LoginForm, WaveSpinner }
})
export default class App extends Vue {
  get isInitializing (): boolean {
    return this.$store.state.initializing
  }

  get isLoggedIn (): boolean {
    return this.$store.getters['account/isLoggedIn']
  }
}
